import { useMediaQuery, useTheme } from "@material-ui/core";

export const mobileSize = "sm";

export const useCheckIsMobile = (mobileSize = "sm") => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(mobileSize));
};
